import React, { Component } from "react";
import { Modal, Row, Col, Select, DatePicker, Input } from "antd";
import axios from "services/axios";
import momentTZ from "moment-timezone";

import { statusMapText } from "../../Utils";
const { Option } = Select;
const { TextArea } = Input;

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalEditBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataBooking: {},
      confirmLoading: false,
      bookingTime: momentTZ(),
      appraiserId: "",
      carType: "",
      notes: "",
      location: "",
    };
  }

  componentDidUpdate(prevProps) {
    const { dataBooking } = this.props;
    if (prevProps.dataBooking.id !== dataBooking.id) {
      this.setState({
        dataBooking,
        carType: dataBooking.carType,
        notes: dataBooking.notes,
        location: dataBooking.location,
        appraiserId: dataBooking.Appraiser ? dataBooking.Appraiser.userId : "",
        loadData: false,
        bookingTime: momentTZ(dataBooking.bookingTime)
          .tz("Asia/Jakarta")
          .format("YYYY-MM-DD HH:mm"),
      });
    }
  }

  saveEditBooking = async () => {
    const { dataBooking, appraiserId, carType, bookingTime, notes } =
      this.state;
    let payload = {
      appraiserId,
      carType,
      bookingTime: momentTZ(bookingTime).tz("Asia/Jakarta").format(),
      notes,
    };
    // let Auth = JSON.parse(localStorage.getItem("userDetail"));
    this.setState({
      confirmLoading: true,
    });
    try {
      await axios.put(`/booking/${dataBooking.id}/update-booking`, payload);
    } catch (err) {
      console.log(err);
    }
    this.setState({
      confirmLoading: false,
    });
    this.props.fetchBooking();
    this.props.toggleShowModal(false);
  };

  selectChange = value => {
    this.setState({
      appraiserId: value,
    });
  };

  inputChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  checkStatus = bookingStatus => {
    let disable = false;
    if (bookingStatus && bookingStatus.length > 0) {
      const findStatus = bookingStatus.find(
        v => v.status_label === "Appraisal"
      );
      if (findStatus && findStatus.status === "Selesai") {
        disable = true;
      }
    }
    return disable;
  };

  render() {
    const { dataBooking } = this.state;
    const { toggleShowModal, showModal, appraiserList } = this.props;
    const disableButton = this.checkStatus(dataBooking.BookingStatuses);
    return dataBooking.id ? (
      <Modal
        title="Booking Appraiser Detail"
        visible={showModal}
        confirmLoading={this.state.confirmLoading}
        onOk={() => this.saveEditBooking()}
        onCancel={() => toggleShowModal(false)}
        width={700}>
        <div>
          <RowForm>
            <Col span={8}>No. Order</Col>
            <Col span={16}>
              <Input value={dataBooking.id} disabled />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Salesman</Col>
            <Col span={16}>
              <Input value={dataBooking.SalesProfile.name} disabled />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Salesman Phone</Col>
            <Col span={16}>
              <Input value={dataBooking.SalesProfile.phone} disabled />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Salesman Whatsapp</Col>
            <Col span={16}>
              <Input value={dataBooking.SalesProfile.whatsapp} disabled />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Cabang</Col>
            <Col span={16}>
              <Input value={dataBooking.SalesProfile.branch} disabled />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Mobil</Col>
            <Col span={16}>
              <Input
                placeholder="Mobil"
                onChange={this.inputChange}
                name="carType"
                value={this.state.carType}
              />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Mobil Baru</Col>
            <Col span={16}>
              <Input
                value={dataBooking.NewCar ? dataBooking.NewCar.carName : null}
                disabled
              />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Jadwal</Col>
            <Col span={16}>
              <DatePicker
                showTime
                value={momentTZ(this.state.bookingTime).tz("Asia/Jakarta")}
                onChange={dateVal => this.setState({ bookingTime: dateVal })}
                style={{ width: "100%" }}
                format="YYYY-MM-DD HH:mm"
                placeholder="Pilih Jam"
                disabled={disableButton ? true : false}
              />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Tempat</Col>
            <Col span={16}>
              <TextArea
                placeholder="location"
                name="location"
                rows={2}
                disabled
                value={this.state.location}
              />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Catatan</Col>
            <Col span={16}>
              <TextArea
                placeholder="notes"
                name="notes"
                rows={4}
                onChange={this.inputChange}
                value={this.state.notes}
              />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Status</Col>
            <Col span={16}>
              <Input
                value={statusMapText(
                  dataBooking.BookingStatuses
                    ? dataBooking.BookingStatuses[0].status_label
                    : null,
                  dataBooking.BookingStatuses
                    ? dataBooking.BookingStatuses[0].status
                    : null
                )}
                disabled
              />
            </Col>
          </RowForm>
          <RowForm>
            <Col span={8}>Appraiser</Col>
            <Col span={16}>
              <Select
                showSearch
                placeholder="Select a person"
                optionFilterProp="children"
                onChange={this.selectChange}
                value={this.state.appraiserId}
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }>
                {appraiserList.map((appraiser, index) => {
                  return (
                    <Option
                      key={index}
                      value={appraiser.userId}
                      style={appraiser.status ? { color: "red" } : {}}>
                      {appraiser.name}
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </RowForm>
        </div>
      </Modal>
    ) : null;
  }
}

export default ModalEditBooking;



// WEBPACK FOOTER //
// src/components/Dashboard/ModalBooking/ModalEditBooking.js